import angular from 'angular';
import uiRouter from 'angular-ui-router';
import 'normalize.css';
import 'angular-material';
import 'angular-aria';
import 'angular-messages';
import Common from './common/common';
import Components from './components/components';
import AppComponent from './app.component';
import interceptor from './common/config/interceptor';

angular
  .module('app', [uiRouter, Common, Components, 'ngMaterial', 'ngMessages'])
  .config(($locationProvider, $httpProvider) => {
    'ngInject';

    // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
    // #how-to-configure-your-server-to-work-with-html5mode
    $locationProvider.html5Mode(true).hashPrefix('!');
    $httpProvider.interceptors.push(interceptor);
  })

  .component('app', AppComponent);



// WEBPACK FOOTER //
// ./client/app/app.js